module.exports = __webpack_public_path__ + "static/img/case1.567eca4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ServiceCase/case1.png
// module id = bm0U
// module chunks = 1